export var isFilled = function isFilled(value) {
  return value !== null && value !== undefined;
};
export var isFiniteNumber = function isFiniteNumber(num) {
  return isFilled(num) && Number.isFinite(num);
};